/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Point2Inputs */

const en_dr_why_point2 = /** @type {(inputs: Dr_Why_Point2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote teams break through less often; collaboration online skews toward late-stage technical work, not concept work (Lin, Frey & Wu 2023, Nature) — a room has to force the conceptual step, on purpose.`)
};

const id_dr_why_point2 = /** @type {(inputs: Dr_Why_Point2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim remote lebih jarang menghasilkan terobosan; kolaborasi online cenderung terpusat di tugas teknis tahap akhir, bukan tahap konsep (Lin, Frey & Wu 2023, Nature) — ruang harus sengaja memaksa langkah konseptual.`)
};

/**
* | output |
* | --- |
* | "Remote teams break through less often; collaboration online skews toward late-stage technical work, not concept work (Lin, Frey & Wu 2023, Nature) — a room h..." |
*
* @param {Dr_Why_Point2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_point2 = /** @type {((inputs?: Dr_Why_Point2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Point2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_point2(inputs)
	return en_dr_why_point2(inputs)
});